import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

const Sidebar = ({ children, className }) => {
  const classes = classNames({
    'create-wizard-layout-sidebar': true,
    [className]: !!className,
  });

  return <div className={classes}>{children}</div>;
};

Sidebar.propTypes = propTypes;

export default Sidebar;
